// Safety net for legacy leads that landed in Firestore with HTML-encoded
// titles or bodies (e.g. `aren&#x27;t safe`). Backend now decodes before
// persisting, but old documents still have raw entities — this keeps the
// inbox/detail views readable without a one-off migration.

const NAMED_ENTITIES = {
  amp: "&",
  quot: '"',
  apos: "'",
  lt: "<",
  gt: ">",
  nbsp: " ",
  ndash: "–",
  mdash: "—",
  hellip: "…",
  lsquo: "‘",
  rsquo: "’",
  ldquo: "“",
  rdquo: "”",
  laquo: "«",
  raquo: "»",
  copy: "©",
  reg: "®",
  trade: "™",
  middot: "·",
  bull: "•",
  cent: "¢",
  pound: "£",
  euro: "€",
  yen: "¥",
  deg: "°",
  para: "¶",
  sect: "§",
  iexcl: "¡",
  iquest: "¿",
  aacute: "á", eacute: "é", iacute: "í", oacute: "ó", uacute: "ú",
  agrave: "à", egrave: "è", igrave: "ì", ograve: "ò", ugrave: "ù",
  acirc: "â", ecirc: "ê", icirc: "î", ocirc: "ô", ucirc: "û",
  auml: "ä", euml: "ë", iuml: "ï", ouml: "ö", uuml: "ü",
  atilde: "ã", ntilde: "ñ", otilde: "õ",
  ccedil: "ç", szlig: "ß",
  Aacute: "Á", Eacute: "É", Iacute: "Í", Oacute: "Ó", Uacute: "Ú",
  Auml: "Ä", Ouml: "Ö", Uuml: "Ü", Ntilde: "Ñ",
};

export function decodeHtmlEntities(input) {
  if (input == null) return "";
  let out = String(input);
  out = out.replace(/&#(x?)([0-9a-fA-F]+);/g, (_, hexFlag, digits) => {
    const code = parseInt(digits, hexFlag ? 16 : 10);
    if (!Number.isFinite(code) || code <= 0 || code > 0x10ffff) return "";
    try {
      return String.fromCodePoint(code);
    } catch {
      return "";
    }
  });
  out = out.replace(/&([a-zA-Z][a-zA-Z0-9]+);/g, (full, name) => {
    if (Object.prototype.hasOwnProperty.call(NAMED_ENTITIES, name)) {
      return NAMED_ENTITIES[name];
    }
    const lower = name.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(NAMED_ENTITIES, lower)) {
      return NAMED_ENTITIES[lower];
    }
    return full;
  });
  return out;
}
